import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from '../../styles/GlobalStyles';

export const Button = styled.button`
  position: absolute;
  z-index: 10;
  right: 0px;
  height: 35px;
  border: none;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  margin: auto 0;
  margin-top: 0;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  
  .menuicon {
    display: block;
    cursor: pointer;
    color: ${props => (props.helpNavScroll > 0 && props.helpNavScroll < 400 ? `${theme.body.dark}` : `${theme.body.light}`)};
    
    transform:  ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: .3s cubic-bezier(0.165, 0.840, 0.440, 1.000); 
    
    &__bar,
    &__circle {
      fill: none;
      stroke: currentColor;
      stroke-width: 1;
      color: ${props => ((props.helpNavScroll > 0 && props.helpNavScroll < 400) || props.isOpen ? `${theme.body.dark}` : `${theme.body.light}`)};
      stroke-linecap: round;
    }
    &__bar {
      transform: rotate(0deg);
      transform-origin: 50% 50%;
      transition: transform .25s ease-in-out;
      stroke-width: 1;
    }
    &__bar:nth-child(1),
    &__bar:nth-child(4) {
      stroke-color: ${theme.icon.whiteIcon};
      opacity: ${props => (props.isOpen ? '0' : '1')};
    }
    &__bar:nth-child(2) {
      transform: ${props => (props.isOpen ? 'rotate(45deg)' : 'rotate(0deg)')};
    }
    &__bar:nth-child(3) {
      transform: ${props => (props.isOpen ? 'rotate(-45deg)' : 'rotate(0deg)')};
    }
    &__circle {
      stroke-width: 2;
      transition: stroke-dashoffset .3s linear .1s;
      stroke-dashoffset: ${props => (props.isOpen ? '0' : '144.513262038')};
      stroke-dasharray: 144.513262038;
    }
  }

  @media (min-width: 990px) {
    display: none;
  }
`;

function ToggleBtn({ toggle, isOpen, helpNavScroll }) {
  return (
    <Button
      onClick={toggle}
      isOpen={isOpen}
      helpNavScroll={helpNavScroll}
      aria-expanded={isOpen ? 'true' : 'false'}
      aria-label="Toggle navigation"
    >
      <svg className="menuicon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <title>Toggle Menu</title>
        <g>
          <line className="menuicon__bar" x1="13" y1="16.5" x2="37" y2="16.5" />
          <line className="menuicon__bar" x1="13" y1="24.5" x2="37" y2="24.5" />
          <line className="menuicon__bar" x1="13" y1="24.5" x2="37" y2="24.5" />
          <line className="menuicon__bar" x1="13" y1="32.5" x2="37" y2="32.5" />
          <circle className="menuicon__circle" r="23" cx="25" cy="25" />
        </g>
      </svg>
    </Button>
  );
}

ToggleBtn.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  helpNavScroll: PropTypes.number,
};

ToggleBtn.defaultProps = {
  helpNavScroll: 500,
};

export default ToggleBtn;
